import { RichTextBlock } from 'prismic-reactjs';
import gql from 'graphql-tag';
import { ILink } from 'utils/types';
import { IBaseSlice, SliceTypes } from '..';
import { PrismicLink } from '../../utils/PrismicTypes';
import { parser } from '../../utils/parsers';

export interface ICta extends IBaseSlice {
  title: string;
  tagline: string;
  text: RichTextBlock[];
  label: string;
  link: ILink;
  graphic: string;
}

export const fragment = (name: string, type: string, fragmentName: string) => gql`
  fragment ${fragmentName || name} on ${type} {
    ... on ${type}${name} {
      type
      primary {
        slice_title
        slice_tagline
        slice_text
        slice_label
        slice_link {
          ...Link
        }
        slice_graphic
      }
    }
  }
`;

type Props = {
  primary: {
    slice_title: RichTextBlock[];
    slice_tagline: RichTextBlock[];
    slice_text: RichTextBlock[];
    slice_label: RichTextBlock[];
    slice_link: PrismicLink;
    slice_graphic: string;
  };
};

export const parse = (slice: Props, redirects): ICta => ({
  type: SliceTypes.Cta,
  title: parser.string(slice.primary.slice_title),
  tagline: parser.string(slice.primary.slice_tagline),
  text: parser.richText(slice.primary.slice_text, redirects),
  label: parser.string(slice.primary.slice_label),
  link: parser.link(slice.primary.slice_link, redirects),
  graphic: parser.string(slice.primary.slice_graphic),
});
